<template>
  <div class="bg-white">
    <CoverPage />
    <Categories />
    <!-- <Form /> -->
    <div class="bge3ceff-opa rounded-t-5555 mt-12">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import CoverPage from "./components/CoverPage.vue";
import Categories from "./components/Categories.vue";
import DownloadApp from "../../home/components/DownloadApp.vue";
import Footer from "../../Footer.vue";
export default {
  components: {
    CoverPage,
    DownloadApp,
    Footer,
    Categories,
  },
};
</script>
